export class ArticleReportAPIModel {
  ReportTypeAPI: string = "";
  ArticleReportAPI: string = "";
  GetJournalList: string = "";
  VolumeIssueListAPI: string = "";
  ArticleExcelReportAPI: string = "";
  ExcelReportAPI: string = "";
}
